<template>
  <div class="content" v-infinite-scroll="getDocs" infinite-scroll-disabled="busy" infinite-scroll-distance="0" infinite-scroll-immediate-check="false">
    <app-loading :active="loading"></app-loading>
    <div class="box">
      <div class="flex">

        <router-link v-for="(document, i) in documents" :key="document.id" :to="'/doc/'+document.id" :tabindex="i+1" class="anchor">
          <app-invoice v-if="document.type == 1" :doc="document"></app-invoice>
          <app-warehouse-doc v-else-if="document.type == 2" :doc="document"></app-warehouse-doc>
          <app-other v-else :doc="document"></app-other>
        </router-link>

        <Empty v-if="documents.length == 0" />
      </div>
    </div>
  </div>
</template>

<script>
import infiniteScroll from 'vue-infinite-scroll'

import Loading from '@/components/Loading.vue'
import Empty from '@/components/Empty.vue'

import Invoice from '@/components/list-items/Invoice.vue'
import WarehouseDoc from '@/components/list-items/WarehouseDoc.vue'
import Other from '@/components/list-items/Other.vue'

export default {
  name: 'docs',
  data () {
    return {
      loading: false,
      initialGet: true
    }
  },
  computed: {
    documents() {
      return this.$store.state.docs.docs
    },
    isLogged() {
      return this.$store.getters['user/isLogged']
    }
  },
  methods: {
    async getDocs() {
      this.loading = true
      const { query } = this.$route.params

      await this.$store.dispatch('docs/getDocs', {
        filters: {
          q: query
        },
        init: this.initialGet
      })

      this.initialGet = false
      this.loading = false
    }
  },
  created() {
    this.getDocs()
  },
  watch: {
    '$route.params'() {
      this.initialGet = true
      this.getDocs()
    }
  },
  metaInfo: {
    title: 'Dokumenty'
  },
  directives: {infiniteScroll},
  components: {
    Empty,
    appInvoice: Invoice,
    appWarehouseDoc: WarehouseDoc,
    appOther: Other,
    appLoading: Loading
  }
}
</script>

<style lang="scss" scoped>
  .anchor {
    outline: none;
  }

  .content {
    margin-bottom: 100px;
  }
</style>

